import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../service/indentifyDevice";
import "../../../assets/scss/components/login/loginScreen/loginScreen.scss";
import "../../../assets/scss/components/login/loginScreen/rmRatingScreen.scss";
import EdButton from "../../generic/edButton";
import { getPreLoginData } from "../../service/login/loginService";
import logo from "../../../assets/images/logo_white.jpg";

export interface IRmRatingScreenProps {
	onSubmit: (body: any) => void;
	onClose?: () => void;
}

export interface IRmRatingScreenState {
	rt: number;
	starHover: number;
	advisorName: string;
	selectedTags: Array<number>;
	showTextarea: boolean;
	feedback: string;
}

class RmRatingScreen extends React.Component<IRmRatingScreenProps, IRmRatingScreenState> {
	state: IRmRatingScreenState = { rt: 0, starHover: 0, advisorName: "Virendra Pawar", selectedTags: [], showTextarea: false, feedback: "" };

	starRatingMsg = [
		"How happy are you with your advisor?",
		"Very Unhappy",
		"Unhappy",
		"Average",
		"Glad you liked it!",
		"Glad to have made you smile!"
	];

	wentWrongTags = ["Quality of Advice", "Professionalism", "Timely Update & Communication", "Execution of Requests", "Other Reasons"];
	complimentTags = [
		{ icon: "edel-icon-star-plus", msg: "6 Star<br/>Service" },
		{ icon: "edel-icon-phone", msg: "Extremely<br/>Professional" },
		{ icon: "edel-icon-people-talk", msg: "Expert<br/>Advise" },
		{ icon: "edel-icon-fast-time", msg: "Timely<br/>Execution" },
		{ icon: "edel-icon-communication", msg: "Excellent<br/>Communication" }
	];

	toggleSelectedTags = (index: number) => {
		let selectedTags: Array<number> = [];

		if (this.state.selectedTags.indexOf(index) > -1) {
			// this tag is already selected
			selectedTags = this.state.selectedTags.filter((tag) => tag !== index);
		} else {
			// select this tag
			selectedTags = [...this.state.selectedTags, index];
		}

		// if star rating is less than 5, then show textarea only if "Other Reasons" is selected
		// otherwise if star rating is 5, the show textarea only is it was previously showing
		this.setState({
			selectedTags,
			showTextarea:
				this.state.rt < 5 ? !!selectedTags.find((tagIndex) => tagIndex === this.wentWrongTags.length - 1) : this.state.showTextarea
		});
	};

	getBodyForApi = (sts: "S" | "C" | "L") => {
		return {
			rt: this.state.rt,
			fbTxt: this.state.rt < 5 && this.state.rt > 0 ? this.state.feedback : null,
			compLst:
				this.state.rt === 5
					? this.state.selectedTags.map((tag) => this.complimentTags[tag].msg.replace(/<br\s*\/>/g, " ")).join(";")
					: null,
			prsNt: this.state.rt === 5 ? this.state.feedback : null,
			fbLst: this.state.rt < 5 && this.state.rt > 0 ? this.state.selectedTags.map((tag) => this.wentWrongTags[tag]).join(";") : null,
			accTyp: getPreLoginData("accTyp"),
			src: "EWIN",
			sts
		};
	};

	handleSubmit = () => {
		this.props.onSubmit(this.getBodyForApi("S"));
	};

	handleNotInterested = () => {
		this.props.onSubmit(this.getBodyForApi("C"));
	};

	handleRemindLater = () => {
		this.props.onSubmit(this.getBodyForApi("L"));
	};

	render() {
		return (
			<LoginPopup
				leftHeaderContent={DeviceContext().isMobile ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
				centerHeaderContent={DeviceContext().isMobile ? undefined : <img src={logo} alt="nuvama" className="nuvama_logo"/>}
				onClose={this.props.onClose}
				className="change_pw_scrn"
			>
				<section className="rmrating_scrn mg-t55 mg-b35">
					<h1 className="title mg-b40">Rate your Advisor</h1>

					<div className="advisor_cont mg-b40">
						<i className="edel-icon-user-circle mg-r20" />
						<div className="advisor_info">
							<p className="name mg-b5">{this.state.advisorName}</p>
							<p>
								<a href="." className="know">
									Know Your Advisor <i className="edel-icon-go ib mg-l5" />
								</a>
							</p>
						</div>
					</div>

					<p className="rating_txt mg-b40">{this.starRatingMsg[this.state.rt]}</p>

					<div className="mg-b40">
						{this.starRatingMsg.map((_, i) => (
							<React.Fragment key={i}>
								{i < 1 ? undefined : (
									<i
										className={"star edel-icon-star-" + (this.state.starHover >= i || this.state.rt >= i ? "filled" : "unfilled")}
										onClick={() => this.setState({ rt: i, selectedTags: [], showTextarea: false })}
										onMouseEnter={() => this.setState({ starHover: i })}
										onMouseLeave={() => this.setState({ starHover: 0 })}
									/>
								)}
							</React.Fragment>
						))}
					</div>

					{this.state.rt > 0 && (
						<p className="tell_us mg-b20">
							{this.state.rt < 5 ? "Tell us what went wrong?" : `Give ${this.state.advisorName} a compliment`}
						</p>
					)}

					{this.state.rt > 0 &&
						(this.state.rt < 5 ? (
							<div className="tags mg-b20">
								{this.wentWrongTags.map((tag, i) => (
									<button
										key={i}
										className={"tag" + (this.state.selectedTags.indexOf(i) > -1 ? " active" : "")}
										onClick={() => this.toggleSelectedTags(i)}
									>
										{tag}
									</button>
								))}
							</div>
						) : (
							<>
								<div className="tags_icons mg-b30">
									{this.complimentTags.map((tag, i) => (
										<button
											key={i}
											className={"tag" + (this.state.selectedTags.indexOf(i) > -1 ? " active" : "")}
											onClick={() => this.toggleSelectedTags(i)}
										>
											<i className={"icon ib mg-b10 " + tag.icon}>
												{this.state.selectedTags.indexOf(i) > -1 && <i className="tick ib edel-icon-tick" />}
											</i>
											<label dangerouslySetInnerHTML={{ __html: tag.msg }} />
										</button>
									))}
								</div>

								{!this.state.showTextarea && (
									<div>
										<EdButton
											value="Write a personalized note"
											btnTyp="secondary"
											slim
											className="mg-b40"
											onClick={() => this.setState({ showTextarea: true })}
										/>
									</div>
								)}
							</>
						))}

					{this.state.showTextarea && (
						<textarea
							value={this.state.feedback}
							className="textarea mg-b40"
							placeholder="Help us understand the situation better. Feel free to write about it."
							onChange={(e) => this.setState({ feedback: e.target.value })}
						/>
					)}

					{this.state.rt > 0 && <EdButton value="Submit" btnTyp="primary" className="submit mg-b15" onClick={this.handleSubmit} />}

					<div>
						<EdButton value="Not Interested" btnTyp="secondary" className="no_bdr not_intr" onClick={this.handleNotInterested} />
						<EdButton value="I'll do it later" btnTyp="secondary" className="no_bdr" onClick={this.handleRemindLater} />
					</div>
				</section>
			</LoginPopup>
		);
	}
}

export default RmRatingScreen;
